module.exports = __webpack_public_path__ + "static/84-d04e52e55a8db206c4aab5967ef430ea.png";